import AddNewClientModal from "./AddNewClientModal";

export default AddNewClientModal;
